export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./photo-plug.vue?vue&type=template&id=17ffe599&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/photo-plug/photo-plug.vue?vue&type=template&id=17ffe599&
// module id = 1190
// module chunks = 0